export default __webpack_public_path__ + "static/media/clinic_default.b38452e6.png";